import React, { Component } from 'react'
import SidebarView from "../SidebarView";
import { checkTranslation, translate } from '../../utils/useful';
import HttpServices from '../../utils/Http.services';
import Modal from '../Modal';
import LoaderButton from '../LoaderButton';
import { FormBuilderObjects } from '../../variables/formBuilderData';
import FormViewer from '../FormViewer';
import ButtonAnimated from '../buttons/ButtonAnimated';

class StackedField extends Component {

    state = {
        fields: [],
        headers: []
    }

    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prev) {
        if (prev.view != this.props.view) {
            this.init()
        }
    }

    init() {
        if (this.props.view?.type) {
            setTimeout(() => {
                let type = this.props.view?.type
                let headers = []
                switch (this.props.view?.type) {
                    case 'matrix':
                        headers = [
                            { key: 'row', type: 'SelectInput', information: { label: '{{lang}}Row Stack', type: 'local', items: this.props.headers?.filter(i => this.getValidFields(type).includes(i.type)), required: true, fields: { title: "information.label", value: "key" } } },
                            { key: 'column', type: 'SelectInput', information: { label: '{{lang}}Column Stack', type: 'local', items: this.props.headers?.filter(i => this.getValidFields(type).includes(i.type)), required: true, fields: { title: "information.label", value: "key" } } },
                            { key: 'viewKey', type: 'SelectInput', information: { label: '{{lang}}Main Card Field', type: 'local', items: this.props.headers, required: true, fields: { title: "information.label", value: "key" }, hint: '{{lang}}You can customize card view using the toolbar -> Data -> Customize card.' } }
                        ]
                        break;
                    case 'kanban':
                        headers = [
                            { key: 'date', type: 'SelectInput', information: { label: '{{lang}}Date Field', type: 'local', items: this.props.headers?.filter(i => this.getValidFields('calendar').includes(i.type)), required: true, fields: { title: "information.label", value: "key" } } },
                            { key: 'time', type: 'SelectInput', information: { label: '{{lang}}Time Field', type: 'local', items: this.props.headers?.filter(i => this.getValidFields('time').includes(i.type)), required: false, fields: { title: "information.label", value: "key" } } },
                            { key: 'viewKey', type: 'SelectInput', information: { label: '{{lang}}Main Card Field', type: 'local', items: this.props.headers, required: true, fields: { title: "information.label", value: "key" }, hint: '{{lang}}You can customize card view using the toolbar -> Data -> Customize card.' } },
                            { key: 'row', type: 'SelectInput', information: { label: '{{lang}}Group field', type: 'local', items: this.props.headers?.filter(i => this.getValidFields('matrix').includes(i.type)), required: false, fields: { title: "information.label", value: "key" } } }
                        ]
                        break;
                    case 'calendar':
                        headers = [
                            { key: 'date', type: 'SelectInput', information: { label: '{{lang}}Date Field', type: 'local', items: this.props.headers?.filter(i => this.getValidFields('calendar').includes(i.type)), required: true, fields: { title: "information.label", value: "key" } } },
                            { key: 'time', type: 'SelectInput', information: { label: '{{lang}}Time Field', type: 'local', items: this.props.headers?.filter(i => this.getValidFields('time').includes(i.type)), required: false, fields: { title: "information.label", value: "key" } } },
                            { key: 'viewKey', type: 'SelectInput', information: { label: '{{lang}}Main Card Field', type: 'local', items: this.props.headers, required: true, fields: { title: "information.label", value: "key" }, hint: '{{lang}}You can customize card view using the toolbar -> Data -> Customize card.' } },
                            { key: 'row', type: 'SelectInput', information: { label: '{{lang}}Group field', type: 'local', items: this.props.headers?.filter(i => this.getValidFields('matrix').includes(i.type)), required: false, fields: { title: "information.label", value: "key" } } }
                        ]
                        break;
                    default:
                        headers = []
                        break;
                }
                let fields = this.props.headers?.filter(i => this.getValidFields(type).includes(i.type))
                // let selectItemFields = []
                // fields.forEach(field => {
                //     selectItemFields.push({ title: field.information?.label, value: field.key })
                // });
                this.setState({ fields, headers })
                if (this.props.defaultStackedKey) {
                    this.radioHandler(this.props.defaultStackedKey?.stackedField)
                }
            }, 100)
        }
    }

    getValidFields = (type) => {
        let accepted = []
        switch (type) {
            case 'kanban':
                accepted = ['LocalSelectInput', 'SelectInput', 'MultiSelectInput', 'AdvancedSelectInput', 'GlobalUserInput', 'DateInput', 'TimeInput', 'DateTimeInput']
                break;
            case 'matrix':
                accepted = ['LocalSelectInput', 'SelectInput', 'MultiSelectInput', 'AdvancedSelectInput', 'GlobalUserInput', 'DateInput', 'TimeInput', 'DateTimeInput']
                break;
            case 'calendar':
                accepted = ['DateInput', 'DateTimeInput']
                break;
            case 'time':
                accepted = ['TimeInput', 'DateTimeInput']
                break;
            default:
                accepted = ['LocalSelectInput', 'SelectInput', 'MultiSelectInput', 'AdvancedSelectInput', 'GlobalUserInput', 'DateInput', 'TimeInput', 'DateTimeInput']
                break;
        }
        return accepted
    }

    radioHandler = (item) => {
        this.setState({ selected: item })
    }

    saveStack = () => {
        let item
        if (this.form) {
            item = this.form.getForm()
        } else {
            item = { stackedField: this.state.selected }
        }
        console.log(item)
        if (item) {
            let data = { frame: this.props.page._id, view: this.props.view?.id, }
            data.settings = {}
            data.settings['stacked'] = item
            if (this.props.changeValue) {
                this.props.changeValue(item)
            }
            // this.setState({ isLoadingPost: true })
            // console.log('addViewSettings', data)

            // TO DO: Send on socket
            // HttpServices.request('addViewSettings', data, (fetchResult, fetchError) => {
            //     this.setState({ isLoadingPost: false })
            //     if (fetchError) { }
            this.init()
            if (this.StackedField) {
                this.StackedField.close()
            }
            let view = this.props.view
            view.settings.stacked = item
            // let view = this.props.view
            // this.props.setData('currentFrame', fetchResult.info)
            this.props.setViews(view.settings)
            // })
        }
    }

    setData = (key, value, reference, cb) => {
        if (reference == 'StackedField') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }

    open = () => {
        this.StackedField.open()
    }

    // addNewUser = () => {
    //     this.newUser.open()
    // }

    // addSingleFeild = () => {
    //     this.singleField.open()
    // }

    changeInputValue = (key, value) => {
        let selected = this.state.selected ?? {}
        selected[key] = value
        this.setState({ selected })
    }

    render() {
        // console.log('this.llls',this.props)
        return (
            <>
                <SidebarView width={this.props.width} ref={el => this.StackedField = el} hideOverlay={false} widthCondition={{ xs: "70%", sm: "50%", md: '40%', lg: "30%", xl: "20%" }} >
                    <div className='h-100' style={{ overflow: 'auto' }}>
                        <div className='flexcb  position-sticky top-0 w-100' style={{ padding: '12px 14px', background: 'linear-gradient(90deg, #fff, #fff)', borderBottom: '1px solid #eee' }}>
                            <div className='flexc'>
                                <p className=' font-size-16 text-semibold'>{translate('Stack by')}</p>
                            </div>
                            <ButtonAnimated
                                iconwidth='24px'
                                onClick={this.state.isLoadingPost ? () => { } : () => { this.saveStack() }}
                                title={translate('Submit')}
                                icon='/assets/icons/plus-white.svg'
                                textColor={this.props.colors?.textColor}
                                invert={this.props.colors?.iconInvert}
                                bg={this.props.colors?.background}
                                isLoading={this.state.isLoadingPost}
                            />
                        </div>
                        <div className=''>
                            <div className=" py-2" style={{}}>
                                <div className="" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexDirection: "column" }}>
                                    <div className="" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexDirection: "column", gap: ".5em" }}>
                                        <div className='w-100 '>
                                            {this.state.fields?.length == 0 && (
                                                <p className='text-small px-2'>{translate("There are no stackable fields in this collection. You can add fields using the 'Add Custom Field' from the 'Data' option in the toolbar.")}</p>
                                            )}
                                            {this.state.fields?.length > 0 && (
                                                <div className="px-3 mb-2">
                                                    <p className=' text-smaller mt-2 color-gray-2 mx-1'>{translate("Choose the field that you want to stack the records based on it")}</p>
                                                </div>
                                            )}
                                            {(this.props.view?.type != 'boards' && this.props.view?.type != 'kanban') && (
                                                <div>
                                                    <FormViewer ref={el => this.form = el} headers={this.state.headers} initData={(this.props.view?.settings?.stacked ?? {})} formClass="modern-form" inputClass={'modern-input'} />
                                                </div>
                                            )}
                                            {/* {((this.props.view?.type == 'matrix' || this.props.view?.type == 'pivot') && Array.isArray(this.state.fields)) && (
                                                <div className=" w-100 px-3 ">
                                                    <div className='mt-3'>
                                                        <p className='text-small text-semibold  mb-2 required px-1'>{translate('Row Stack')}</p>
                                                        <div className='modern-input'>
                                                            <SelectInput data={this.state.selected?.row} header={{ key: 'row', information: { type: 'local', items: this.state.selectItemFields } }} changeValue={this.changeInputValue} />
                                                        </div>
                                                    </div>
                                                    <div className='mt-3'>
                                                        <p className='text-small text-semibold  mb-2 required px-1'>{translate('Column Stack')}</p>
                                                        <div className='modern-input'>
                                                            <SelectInput data={this.state.selected?.column} header={{ key: 'column', information: { type: 'local', items: this.state.selectItemFields } }} changeValue={this.changeInputValue} />
                                                        </div>
                                                    </div>
                                                    <div className='mt-3'>
                                                        <p className='text-small text-semibold  mb-2 required px-1'>{translate('Main Card Field')}</p>
                                                        <div className='modern-input'>
                                                            <SelectInput data={this.state.selected?.viewKey} header={{ key: 'viewKey', information: { type: 'local', items: this.props.headers, fields: { title: "information.label", value: "key" } } }} changeValue={this.changeInputValue} />
                                                        </div>
                                                        <p className='text-smaller   mt-2 px-1'>{translate('You can customize card view using the toolbar -> Data -> Customize card.')}</p>
                                                    </div>
                                                </div>
                                            )} */}
                                            {/* {((this.props.view?.type == 'calendar') && Array.isArray(this.state.fields)) && (
                                                <div className=" w-100 px-3 ">
                                                    <div className='mt-3'>
                                                        <p className='text-small text-semibold  mb-2 required px-1'>{translate('Row Stack')}</p>
                                                        <div className='modern-input'>
                                                            <SelectInput data={this.state.selected?.row} header={{ key: 'row', information: { type: 'local', items: this.state.selectItemFields } }} changeValue={this.changeInputValue} />
                                                        </div>
                                                    </div>
                                                    <div className='mt-3'>
                                                        <p className='text-small text-semibold  mb-2 required px-1'>{translate('Main Card Field')}</p>
                                                        <div className='modern-input'>
                                                            <SelectInput data={this.state.selected?.viewKey} header={{ key: 'viewKey', information: { type: 'local', items: this.props.headers, fields: { title: "information.label", value: "key" } } }} changeValue={this.changeInputValue} />
                                                        </div>
                                                        <p className='text-smaller   mt-2 px-1'>{translate('You can customize card view using the toolbar -> Data -> Customize card.')}</p>
                                                    </div>
                                                    <div className='mt-3'>
                                                        <p className='text-small text-semibold  mb-2 px-1'>{translate('Group field')}</p>
                                                        <div className='modern-input'>
                                                            <SelectInput data={this.state.selected?.column} header={{ key: 'column', information: { type: 'local', items: this.state.selectItemFields } }} changeValue={this.changeInputValue} />
                                                        </div>
                                                    </div>
                                                </div>
                                            )} */}
                                            {(this.props.view?.type == 'boards' || this.props.view?.type == 'kanban') && (
                                                <div className="stacked-item w-100">
                                                    {Array.isArray(this.state.fields) && this.state.fields?.map((prop, index) => {
                                                        let base = FormBuilderObjects[prop.type]
                                                        let selected = this.state.selected == prop.key
                                                        return (
                                                            <div key={prop.key}>
                                                                <div className='px-1 w-100' style={{ borderBottom: '1px solid #eee' }}>
                                                                    <button className="pld-2 py-2 flexcb w-100" style={{}} onClick={() => this.radioHandler(prop.key)}>
                                                                        {/* <input className='mrd-2' type="radio" checked={this.state.selected == prop.key} /> */}
                                                                        <div className='flexc'>
                                                                            <div className='br-20 mrd-2 flexcc p-1' style={{ width: 16, height: 16, border: selected ? '1px solid rgb(88, 86, 214)' : '1px solid #bbb', }}>
                                                                                <div className='flexcc'>
                                                                                    <div className='br-20' style={{ background: selected ? 'rgb(88, 86, 214)' : null, width: 11, height: 11, }}>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='text-start mx-1'>
                                                                                <p className='' style={{ fontSize: "14px" }} key={index}>{checkTranslation(prop?.information?.label)} </p>
                                                                                <p className='text-smaller color-gray-1' style={{}} key={index}>{checkTranslation(base?.label)} Field</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className='px-2'>
                                                                            <img className='' src={base?.icon} width={22} />
                                                                        </div>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </SidebarView>
                <Modal minWidth={400} ref={el => this.stacedModal = el}>
                    <div className='p-3 my-2' style={{ background: "#fff", borderRadius: '10px' }}>
                        <div className="flexcb px-2 py-1" style={{ position: 'sticky', top: 0, zIndex: 1, boxShadow: '0px 0px 30px #10101010', borderBottom: '1px solid #f6f6f6', background: this.props.background ?? 'linear-gradient(to right, #fff , #fff)', backgroundColor: '#fff' }}>
                            <p className="text-bold py-1 px-2">{translate('Stack by')}</p>
                        </div>
                        <div className=''>
                            <div className="px-2 py-2" style={{}}>
                                <div className="" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexDirection: "column" }}>
                                    <div className="" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexDirection: "column", gap: ".5em" }}>
                                        <div className="px-2">
                                            <p className='text-small' style={{ color: "#404040" }}>{translate("Choose the field that you want to stack the records based on it")}</p>
                                        </div>
                                        <div className="stacked-item w-100">
                                            {Array.isArray(this.props.headers) && this.state.fields?.map((prop, index) => {
                                                let icon = FormBuilderObjects[prop.type]?.icon
                                                return (
                                                    <div className='' key={index}>
                                                        <label className="pld-2 py-1 d-flex" style={{ paddingBottom: 5 }} onClick={() => { this.radioHandler(prop.key); this.stacedModal.hideModal() }}>
                                                            <input className='mrd-2' type="radio" checked={this.state.selected == prop.key} />
                                                            <img src={icon} width={20} />
                                                            <p style={{ fontSize: "14px" }} key={index}>{checkTranslation(prop?.information?.label)} </p>
                                                        </label>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                {/* single select field */}
            </>
        );
        // <SidebarView ref={el => this.singleField = el} widthCondition={{ xs: "60%", sm: "50%", md: '60%', lg: "50%", xl: "40%" }}>
        //     <div className="flexcc" style={{ height: "100%", backgroundColor: "rgb(170, 176, 207", width: "100%" }}>
        //         <div className="flexcc flex-column" style={{ backgroundColor: "#fff", gap: "1.5em", height: "200px", width: "300px", boxShadow: "0px 0px 30px #10101030", borderRadius: "15px" }}>
        //             {/* style={{backgroundColor:"#fff",borderRadius:"15px",boxShadow:"0px 0px 30px #10101090",height:"100vh"}} */}
        //             <div className="" style={{ fontWeight: "bold" }}>
        //                 <p>Field name</p>
        //             </div>
        //             <div className="flexcb flex-column" style={{ gap: "1em" }}>
        //                 <div className="">
        //                     <input className="p-2" type="text" placeholder="Insert your field name" style={{ width: "250px", border: "none", backgroundColor: "#e8e8e8", borderRadius: "5px" }} />
        //                 </div>
        //                 <div className="py-2 px-3 flexcc" style={{ backgroundColor: "rgb(46, 76, 207", borderRadius: '5px' }}>
        //                     <button style={{ color: "#fff" }}>Done</button>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </SidebarView>
        // <SidebarView ref={el => this.newUser = el} widthCondition={{ xs: "60%", sm: "50%", md: '60%', lg: "50%", xl: "40%" }}>
        //     <div className="flexcc" style={{ height: "100%", backgroundColor: "rgb(170, 186, 207", width: "100%" }}>
        //         <div className="flexcc flex-column" style={{ backgroundColor: "#fff", gap: "1.5em", height: "200px", width: "300px", boxShadow: "0px 0px 30px #10101030", borderRadius: "15px" }}>
        //             {/* style={{backgroundColor:"#fff",borderRadius:"15px",boxShadow:"0px 0px 30px #10101090",height:"100vh"}} */}
        //             <div className="" style={{ fontWeight: "bold" }}>
        //                 <p>Field name</p>
        //             </div>
        //             <div className="flexcb flex-column" style={{ gap: "1em" }}>
        //                 <div className="flexcc" style={{ flexDirection: "column", gap: ".5em" }}>
        //                     <input className="p-2" type="text" placeholder="Insert your field name" style={{ width: "250px", border: "none", backgroundColor: "#e8e8e8", borderRadius: "5px" }} />
        //                     <div className="flexc newuser-field w-100" style={{ gap: ".3em" }}>
        //                         <SwitchInput header={{ information: {} }} />
        //                         <p className='' style={{ fontSize: 10 }}>notify collaborators when they're added</p>
        //                     </div>
        //                 </div>
        //                 <div className="py-2 px-3 flexcc" style={{ backgroundColor: "rgb(170, 186, 207", borderRadius: '5px' }}>
        //                     <button style={{ color: "#fff" }}>Done</button>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </SidebarView>
    }
}

export default StackedField;